module.exports = __webpack_public_path__ + "img/research-conservation.48cae0ff.jpg";